export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'Je savais ce que je voulais écrire, mais pas toujours comment structurer efficacement mes informations. Les prompts m’ont donné une méthode beaucoup plus claire.',
    name: 'Témoignage client',
    location: 'France',
    flag: '🇫🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/3b0c83aa-dbc2-4f4d-8652-cc139f27d6c0.jpg',
  },
  {
    quote:
      'Le fait d’avoir les prompts classés par situation change complètement l’utilisation de l’IA. Je ne pars plus d’une page blanche.',
    name: 'Témoignage client',
    location: 'Belgique',
    flag: '🇧🇪',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/0584dc22-8540-4131-aa60-b9065f6aeead.jpg',
  },
  {
    quote:
      'Ce que j’apprécie surtout, c’est la structure. Je peux prendre mes informations et les organiser beaucoup plus rapidement.',
    name: 'Témoignage client',
    location: 'Suisse',
    flag: '🇨🇭',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/b730c42c-2c40-4297-a406-78f2871df410.jpg',
  },
];
